import React from 'react';
import { motion } from 'framer-motion';
import { ChevronRight, Star, FileText, ShieldCheck } from 'lucide-react';
export const Hero = () => {
  const scrollToBuy = () => {
    document.getElementById('buy-section')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  const badges = [{
    icon: <Star className="w-4 h-4 fill-lime-400 text-lime-400" data-id="element-131" />,
    text: '4.8/5.0'
  }, {
    icon: <FileText className="w-4 h-4 text-lime-400" data-id="element-132" />,
    text: 'Entrega Inmediata PDF'
  }, {
    icon: <ShieldCheck className="w-4 h-4 text-lime-400" data-id="element-133" />,
    text: 'Pago Seguro'
  }];
  return <section className="w-full pt-14 pb-16 px-4 flex flex-col items-center text-center bg-zinc-950 relative overflow-hidden" data-id="element-134">
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full max-w-3xl h-[500px] bg-lime-500/10 blur-[120px] rounded-full pointer-events-none" data-id="element-135"></div>

      <motion.h1 initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} className="text-4xl md:text-6xl lg:text-7xl font-bold uppercase tracking-tight max-w-5xl mb-8 text-white leading-[1.1] z-10 font-oswald" data-id="element-136">
        Si entrenas mucho en la semana y en el partido{' '}
        <span className="text-lime-400" data-id="element-137">no se ve</span> esto es para vos
      </motion.h1>

      <motion.div initial={{
      opacity: 0,
      scale: 0.95
    }} animate={{
      opacity: 1,
      scale: 1
    }} transition={{
      delay: 0.2,
      duration: 0.5
    }} className="w-full max-w-[640px] mb-6 cursor-pointer relative group z-10" onClick={scrollToBuy} data-id="element-138">
        <div className="absolute inset-0 bg-lime-400/20 blur-3xl rounded-full group-hover:bg-lime-400/30 transition-all duration-500 opacity-0 group-hover:opacity-100" data-id="element-139"></div>
        <img src="https://cdn.magicpatterns.com/uploads/bv29xmTbvEWFmVkL9kmPTC/ChatGPT_Image_May_26__2026__10_47_26_PM-removebg-preview.png" alt="Rugby Performance System" className="w-full h-auto relative z-10 drop-shadow-2xl group-hover:scale-[1.02] transition-transform duration-500" data-id="element-140" />
      </motion.div>

      <motion.p initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} transition={{
      delay: 0.4
    }} className="text-base md:text-lg text-zinc-300 max-w-2xl mb-6 font-medium z-10 leading-snug" data-id="element-141">
        El sistema de entrenamiento diseñado para desarrollar las capacidades
        que{' '}
        <span className="text-white font-bold border-b-2 border-lime-400" data-id="element-142">
          realmente determinan tu rendimiento
        </span>{' '}
        dentro de una cancha de rugby.
      </motion.p>

      <motion.div initial={{
      opacity: 0,
      y: 10
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      delay: 0.5
    }} className="flex flex-wrap items-center justify-center gap-2 md:gap-3 mb-8 z-10" data-id="element-143">
        {badges.map((badge, idx) => <div key={idx} className="flex items-center gap-1.5 bg-zinc-900/80 border border-zinc-800 px-3 py-1.5 rounded-full text-xs md:text-sm font-semibold text-zinc-200" data-id="element-144">
            {badge.icon}
            <span data-id="element-145">{badge.text}</span>
          </div>)}
      </motion.div>

      <motion.button initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      delay: 0.6
    }} onClick={scrollToBuy} className="bg-lime-500 hover:bg-lime-400 text-zinc-950 font-black text-xl md:text-3xl py-5 px-10 rounded-xl uppercase tracking-wider flex items-center justify-center gap-3 shadow-[0_0_40px_rgba(132,204,22,0.3)] hover:shadow-[0_0_60px_rgba(132,204,22,0.5)] transition-all duration-300 transform hover:-translate-y-1 w-full max-w-2xl z-10 font-oswald" data-id="element-146">
        QUIERO MEJORAR MI RENDIMIENTO
        <ChevronRight className="w-8 h-8 md:w-10 md:h-10" strokeWidth={3} data-id="element-147" />
      </motion.button>
    </section>;
};